/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Opencontactdetailbeforeaccepting4Inputs */

const en_entity_opencontactdetailbeforeaccepting4 = /** @type {(inputs: Entity_Opencontactdetailbeforeaccepting4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Contact Detail Before Accepting`)
};

const de_entity_opencontactdetailbeforeaccepting4 = /** @type {(inputs: Entity_Opencontactdetailbeforeaccepting4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktdetails vor Annahme öffnen`)
};

/**
* | output |
* | --- |
* | "Open Contact Detail Before Accepting" |
*
* @param {Entity_Opencontactdetailbeforeaccepting4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_opencontactdetailbeforeaccepting4 = /** @type {((inputs?: Entity_Opencontactdetailbeforeaccepting4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Opencontactdetailbeforeaccepting4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_opencontactdetailbeforeaccepting4(inputs)
	return de_entity_opencontactdetailbeforeaccepting4(inputs)
});
export { entity_opencontactdetailbeforeaccepting4 as "entity_openContactDetailBeforeAccepting" }